import { useState } from 'react';
import { useAiScheduleAccess } from '@frontend/ai-receptionist-settings';
import { useDebouncedValue } from '@frontend/design-system';
import { ManageProvidersAvailabilityBanner } from '../../components/manage-providers-availability-banner';
import { ManagePractitionersV3Table } from '../../components/ManagePractitionersV3/ManagePractitionersV3Table';
import { ScheduleSettingsSection } from '../../components/settings';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';
import { PageConfig } from '../../types';

type ManagePractitionerV3PageProps = {
  locationId?: string;
};

export const ManagePractitionersV3Page = ({ locationId }: ManagePractitionerV3PageProps) => {
  const { selectedLocationIds } = useSchedulingLocationInfo();
  const selectedLocationId = locationId || selectedLocationIds[0] || '';
  const { hasAiReceptionistAccess } = useAiScheduleAccess();

  const [pageConfig, setPageConfig] = useState<PageConfig>({
    page: 1,
    limit: 10,
    searchValue: '',
  });

  const debouncedSearchValue = useDebouncedValue(pageConfig.searchValue, 400);

  return (
    <ScheduleSettingsSection transparentInSmallMode>
      {hasAiReceptionistAccess && <ManageProvidersAvailabilityBanner />}
      <ManagePractitionersV3Table
        pageConfig={pageConfig}
        setPageConfig={setPageConfig}
        locationId={selectedLocationId}
        debouncedSearchValue={debouncedSearchValue}
        disableProviderActions={hasAiReceptionistAccess}
      />
    </ScheduleSettingsSection>
  );
};
